"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_TOKEN_KEY = exports.REFRESH_TOKEN_KEY = exports.ID_TOKEN_KEY = exports.SECRET_KEY = exports.AUTH = void 0;
__exportStar(require("./error.code.enum"), exports);
__exportStar(require("./auth.message"), exports);
__exportStar(require("./storage.enum"), exports);
__exportStar(require("./provider.enum"), exports);
exports.AUTH = 'auth';
exports.SECRET_KEY = "defaultsecret";
exports.ID_TOKEN_KEY = 'info-auth-id-token';
exports.REFRESH_TOKEN_KEY = 'info-auth-refresh-token';
exports.ACCESS_TOKEN_KEY = 'info-auth-access-token';
//# sourceMappingURL=index.js.map